import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import WallOfShame from "./components/WallOfShame";
import App from "./components/App";
import { unregister } from "./registerServiceWorker";
import { Router, navigate } from "@reach/router";
import onInactivity from "./util/onInactivity";

unregister();

window.navigate = navigate;

onInactivity(() => {
  // eslint-disable-next-line
  location.reload();
});

const app = (
  <Router>
    <App path="/" />
    <WallOfShame path="/wall-of-shame" />
  </Router>
);

ReactDOM.render(app, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js